module.exports = __webpack_public_path__ + "static/media/kyc_first.9ef72e9f.svg";